import { Link } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

import './index.styles.css'
interface Props {
  event: CalendarEvent
}

const PostEvent = ({ event }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Link
      className={'Event_link'}
      to={navigation.dashboard.post.id.fullPath({ id: event.metadata('id') })}
    >
      <span>{event.metadata('title')}</span>
    </Link>
  )
}

export default PostEvent
